<template>
  <select
    v-model="input"
    :class="['form-control', 'custom-select', ...classNames]"
    @change="handleChange"
  >
    <option
      v-for="(option, index) in options"
      :key="index"
      :value="option.value"
      :disabled="option.disabled"
    >
      {{ option.text }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'BaseDropdown',

  props: {
    value: [String, Number, Boolean],
    options: [Array],
    classNames: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      input: null,
    }
  },

  watch: {
    value () {
      this.input = this.value
    },
    input () {
      this.$emit('input', this.input)
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    handleChange (e) {
      this.$emit('input', this.input)
      this.$emit('change', e)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseDropdown.vue